import algoliasearch from "algoliasearch";
import FilterParamsUtil from "./filter-params-util";

import Wishlist from "../../common/wishlist";
const wishlist = Wishlist();

const PER_PAGE = 50;

const shouldAlgoliasearch = (filterParams, sectionParams) => {
  if (sectionParams.collection.handle == "all") {
    return true;
  }
  const shouldAlgoliasearchKeys = FilterParamsUtil.shouldAlgoliasearchKeys;
  if (0 <= filterParams.findIndex((kv) => shouldAlgoliasearchKeys.includes(kv.key))) {
    return true;
  }
  return false;
};

const algoliasearchIndexName = (sortType) => {
  if (sortType == "price_asc") {
    return "shopify_prod_products_price_asc";
  } else if (sortType == "price_desc") {
    return "shopify_prod_products_price_desc";
  }
  return "shopify_prod_products_published_at_desc";
};

const queryAlgoliasearch = (lastResult, filterParams, sectionParams, callback) => {
  const params = FilterParamsUtil.createAlgoliasearchParams(filterParams, sectionParams);
  const sortType = FilterParamsUtil.currentSortType(filterParams, sectionParams);
  const indexName = algoliasearchIndexName(sortType);
  const page = FilterParamsUtil.currentPage(filterParams);
  const client = algoliasearch("ZGISPFZEQK", "ebbe04351ebe8091e1d417fe4ed7d8b3").initIndex(indexName);

  client
    .search(params.q, {
      distinct: false,
      clickAnalytics: true,
      hitsPerPage: PER_PAGE,
      page: page - 1,
      filters: params.filters.join(" AND "),
      numericFilters: params.numericFilters,
      facetFilters: params.facetFilters,
    })
    .then((result) => {
      const resultColor = distinctColorForAlgoliaHits(result.page, lastResult?.products ?? [], result.hits);
      result.hits.forEach((product) => wishlist.addAlgoliaProductToViewProducts(product));
      callback({
        resultType: "algolia",
        products: resultColor,
        page: result.page + 1,
        nbPages: result.nbPages,
        indexName: indexName,
        queryID: result.queryID,
      });
    })
    .catch((err) => {
      console.error(err);
    });
};

const queryShopify = (filterParams, sectionParams, callback) => {
  let productIds = [];
  if (sectionParams.collection.handle == "all") {
    let page = FilterParamsUtil.currentPage(filterParams);
    if (sectionParams.collection_all_top.pagination.current_page != page) {
      FilterParamsUtil.pushHistory(filterParams);
      location.reload();
      return;
    }
    if (sectionParams.collection_all_top.pagination.pages < page) {
      queryAlgoliasearch(filterParams, sectionParams, callback);
      return;
    }
    const inventoryAvailable = FilterParamsUtil.inventoryAvailable(filterParams);
    productIds = inventoryAvailable
      ? sectionParams.collection_all_top.available_product_ids
      : sectionParams.collection_all_top.product_ids;
  } else {
    productIds = sectionParams.collection.product_ids;
  }

  const ids = productIds.map((id) => "gid://shopify/Product/" + id);
  window.ShopifyClient.fetchProducts(ids)
    .then((products) => {
      products.forEach((product) => wishlist.addShopifyProductToViewProducts(product));
      callback({
        resultType: "shopify",
        products: products,
      });
    })
    .catch((err) => {
      /* console.error(err) */
    });
};

let lastCollection = null;
let lastParent = null;
const queryOtherCollection = (filterParams, sectionParams, otherCallback) => {
  const collection = filterParams.find((fp) => fp.key == "collections");
  if (!collection) {
    otherCallback({ resultType: "algolia", products: [], page: 1, nbPages: 0, indexNamne: "", queryID: "" });
    return;
  }
  let parent = null;
  for (const cl0 of sectionParams.category_list) {
    if (cl0.handle == collection.value) {
      break;
    }
    for (const cl1 of cl0.items) {
      if (cl1.handle == collection.value) {
        parent = cl0;
        break;
      }
    }
  }
  if (!parent) {
    otherCallback({ resultType: "algolia", products: [], page: 1, nbPages: 0, indexNamne: "", queryID: "" });
    return;
  }
  if (lastParent && lastParent.handle == parent.handle && lastCollection && collection.value == lastCollection.value) {
    return;
  }
  lastCollection = collection;
  lastParent = parent;
  const params = [
    `collections:-${collection.value}`,
    `collections:${parent.handle}`,
    "product_type:-OPTION",
    "tags:-outlet",
  ];
  const indexName = "shopify_prod_products_published_at_desc";
  const client = algoliasearch("ZGISPFZEQK", "ebbe04351ebe8091e1d417fe4ed7d8b3").initIndex(indexName);

  client
    .search("", {
      distinct: false,
      hitsPerPage: PER_PAGE,
      page: 0,
      facetFilters: params,
    })
    .then((result) => {
      const resultColor = distinctColorForAlgoliaHits(result.page, [], result.hits);
      result.hits.forEach((product) => wishlist.addAlgoliaProductToViewProducts(product));
      otherCallback({
        resultType: "algolia",
        products: resultColor,
        page: result.page + 1,
        nbPages: result.nbPages,
        indexName: indexName,
        queryID: result.queryID,
      });
    })
    .catch((err) => {
      console.error(err);
    });
};

const distinctColorForAlgoliaHits = (algoliaPage, lastProducts, products) => {
  console.log(lastProducts);

  let lastProduct = 0 < lastProducts.length ? lastProducts[lastProducts.length - 1] : null;
  if (algoliaPage == 0) {
    lastProducts = null;
  }

  const results = [];
  for (const product of products) {
    if (
      lastProducts &&
      0 <= lastProducts.findIndex((lp) => lp.id == product.id && lp.options["色"] == product.options["色"])
    ) {
      continue;
    }
    if (0 <= results.findIndex((lp) => lp.id == product.id && lp.options["色"] == product.options["色"])) {
      continue;
    }
    results.push(product);
  }
  if (algoliaPage == 0) {
    return results;
  }
  return [...lastProducts, ...results];
};

const run = (lastResult, filterParams, sectionParams, callback, otherCallback) => {
  if (!["all", "familysale2025"].includes(sectionParams.collection.handle)) {
    if (0 <= filterParams.findIndex((kv) => kv.key == "vendor" && kv.value != sectionParams.collection.title)) {
      const searchParams = FilterParamsUtil.generateSearchParams(filterParams);
      const strSearch = searchParams.toString();
      const path = `/collections/all${0 < strSearch.length ? "?" : ""}${strSearch}`;
      location.href = path;
      return;
    }
  }
  if (shouldAlgoliasearch(filterParams, sectionParams)) {
    queryAlgoliasearch(lastResult, filterParams, sectionParams, callback);
  } else {
    queryShopify(filterParams, sectionParams, callback);
  }
  if ("all" == sectionParams.collection.handle) {
    queryOtherCollection(filterParams, sectionParams, otherCallback);
  }
};

const QueryProducts = {
  run: run,
};

export default QueryProducts;
